import React from "react";
import Header from "../../header";
import ReactInputVerificationCode from "react-input-verification-code";
import { apiCall_domain, token } from "../../api";
import axios from "axios";
import PulseLoader from "react-spinners/PulseLoader";
class forgetPassStep1 extends React.Component {
  state = {
    changeDetail: true,
    VerificationCode: "",
    error: "",
    count: 26,
    loading: false,
    countVar: true,
  };

  setTimer = () => {
    this.setState({ count: 26 });
    const Interval = setInterval(() => {
      this.setState({ count: this.state.count - 1 }, () => {
        if (this.state.count === 0) {
          clearInterval(Interval);
        }
      });
    }, 1000);
  };

  componentDidMount() {
    this.setTimer();
  }

  render() {
    const SetVerificationCode = (e) => {
      this.setState({ VerificationCode: e });
    };
    const handleSubmit = () => {
      this.setState({ loading: true });
      const Data = {
        phone: localStorage.getItem("phone"),
        code: this.state.VerificationCode,
      };
      const headers = {
        Authorization: token(),
        "content-type": "application/json",
      };
      axios
        .post(`${apiCall_domain}/customer/auth/chk_code`, Data, {
          headers: headers,
        })
        .then((res) => {
          if (res.data === 0) {
            this.setState({
              loading: false,
              error: "کد تایید اشتباه است",
            });
          } else {
            this.props.history.push({
              pathname: "/EnterPass/forgetPassStep2",
              state: this.state.VerificationCode,
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            error: "کد تایید را وارد کنید",
          });
        });
    };
    const resendCode = () => {
      this.setState({ loading: true });
      if (this.state.count === 0) {
        const headers = {
          Authorization: token(),
          "content-type": "application/json",
        };
        const Data3 = {
          phone: localStorage.getItem("phone"),
        };
        axios
          .post(`${apiCall_domain}/customer/auth/resend_code`, Data3, {
            headers: headers,
          })
          .then((res) => {
            this.setTimer();
            this.setState({
              error: res.data.message,
              loading: false,
              countVar: false,
            });
          });
      }
    };
    return (
      <>
        <div className="EnterPass">
          <Header showSearchBar={true} title={"کد تایید"} />
          <div className="phoneBox">
            <div className="phoneTitle">
              کد ارسال شده به شماره {this.props.location.phone} را وارد کنید
            </div>
            <ReactInputVerificationCode
              length={5}
              placeholder=""
              onChange={(e) => SetVerificationCode(e)}
            />
            <div className="resendCode">
              {this.state.count === 0 ? (
                <span
                  className="resend getResendCode"
                  onClick={() => resendCode()}
                >
                  دریافت کد
                </span>
              ) : (
                // this.state.countVar && this.state.count !== 0 &&
                <span className="resend">هنوز کد را دریافت نکرده اید؟</span>
              )}
              <span className="Seconds">
                {this.state.count} ثانیه تا ارسال مجدد
              </span>
            </div>
            <div className="error">{this.state.error}</div>
          </div>
          <div className="mySecContinue EnterCodeBtn">
            {this.state.loading ? (
              <button className="btn disabled">
                <PulseLoader size={12} color="#fff" loading={true} />
              </button>
            ) : (
              <button onClick={(e) => handleSubmit(e)}>تایید</button>
            )}
          </div>
        </div>
      </>
    );
  }
}
export default forgetPassStep1;
